/* SEDUCTIVE — tema "Asporto". Nessuna libreria, solo il necessario. */
(function () {
  'use strict';

  var cfg = window.Seductive || {};
  var routes = cfg.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var strings = cfg.strings || {};
  var root = document.documentElement;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------
     Toast
  ------------------------------------------------------------------ */
  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 4200);
  }

  /* ------------------------------------------------------------------
     Drawers (carrello, menu, guida taglie, scelta taglia)
  ------------------------------------------------------------------ */
  var openEl = null;
  var returnFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function overlay() { return $('[data-overlay]'); }

  function openDrawer(name, trigger) {
    var el = $('[data-drawer="' + name + '"]');
    if (!el) return false;
    if (openEl && openEl !== el) closeDrawer(true);
    if (trigger) returnFocus = trigger;
    else if (!returnFocus) returnFocus = document.activeElement;

    el.hidden = false;
    var ov = overlay();
    if (ov) ov.hidden = false;
    // forza il reflow così la transizione parte
    void el.offsetWidth;
    el.classList.add('is-open');
    if (ov) ov.classList.add('is-visible');
    root.classList.add('is-locked');
    openEl = el;
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (name === 'cart') stampReceipt(el);
    setTimeout(function () {
      var target = $('[data-autofocus]', el) || el;
      target.focus({ preventScroll: true });
    }, 60);
    return true;
  }

  function closeDrawer(switching) {
    var el = openEl;
    if (!el) return;
    el.classList.remove('is-open');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var hide = function () { if (!el.classList.contains('is-open')) el.hidden = true; };
    setTimeout(hide, 420);
    openEl = null;
    if (switching === true) return;
    var ov = overlay();
    if (ov) {
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!openEl) ov.hidden = true; }, 320);
    }
    root.classList.remove('is-locked');
    if (returnFocus && document.body.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  }

  function trapFocus(e) {
    var items = $$(FOCUSABLE, openEl).filter(function (n) { return n.offsetParent !== null; });
    if (!items.length) { e.preventDefault(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === openEl)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  // I drawer dentro alle sezioni (es. menu nell'header) vengono spostati nel body,
  // così l'header sticky non li intrappola nel suo livello.
  function hoistDrawers(scope) {
    $$('[data-drawer][data-hoist]', scope || document).forEach(function (d) {
      if (d.parentElement === document.body) return;
      var old = d.id ? document.getElementById(d.id) : null;
      $$('body > [data-drawer="' + d.getAttribute('data-drawer') + '"]').forEach(function (n) { if (n !== d) n.remove(); });
      if (old && old !== d && old.parentElement === document.body) old.remove();
      document.body.appendChild(d);
    });
  }

  /* ------------------------------------------------------------------
     Carrello: AJAX + Section Rendering API
  ------------------------------------------------------------------ */
  function setBusy(btn, busy) {
    if (!btn) return;
    btn.classList.toggle('is-busy', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function sectionIds() {
    var ids = ['cart-drawer'];
    $$('[data-cart-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section-id');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function cartRequest(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || strings.error || 'Errore');
        }
        return data;
      });
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (String(count) === '0') el.setAttribute('data-empty', '');
      else el.removeAttribute('data-empty');
    });
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var fresh = $('[data-cart-inner]', doc);
        var current = $('[data-cart-inner]');
        if (fresh && current) {
          current.replaceWith(fresh);
          updateCount(fresh.getAttribute('data-count'));
          stampReceipt(fresh);
        }
      } else {
        var f = $('[data-cart-section-id="' + id + '"]', doc);
        var c = $('[data-cart-section-id="' + id + '"]');
        if (f && c) c.replaceWith(f);
      }
    });
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    setBusy(btn, true);
    return cartRequest(routes.cart_add_url, { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (data) {
        renderSections(data.sections);
        openDrawer('cart', btn && document.body.contains(btn) ? btn : null);
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { setBusy(btn, false); });
  }

  function changeLine(line, quantity, btn) {
    setBusy(btn, true);
    return cartRequest(routes.cart_change_url, { line: Number(line), quantity: Number(quantity) })
      .then(function (data) {
        if (document.body.getAttribute('data-template') === 'cart') {
          window.location.reload();
          return;
        }
        renderSections(data.sections);
        var first = openEl && $(FOCUSABLE, openEl);
        if (first) first.focus({ preventScroll: true });
      })
      .catch(function (err) { toast(err.message); setBusy(btn, false); });
  }

  // data e ora sullo scontrino, prese dal telefono di chi compra
  function stampReceipt(scope) {
    var el = $('[data-receipt-time]', scope || document);
    if (!el) return;
    var d = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    el.textContent = pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() + '  ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  /* ------------------------------------------------------------------
     Pagina prodotto
  ------------------------------------------------------------------ */
  function lowStockText(qty, size) {
    var tpl = qty === 1 ? (strings.lowOne || 'Ultimo pezzo in taglia [size]') : (strings.lowMany || 'Ultimi [count] in taglia [size]');
    return tpl.replace('[count]', qty).replace('[size]', size);
  }

  function initProductForm(form) {
    if (form.__ready) return;
    form.__ready = true;
    var input = $('[data-variant-input]', form);
    var note = $('[data-stock-note]', form);
    var hint = $('[data-size-hint]', form);
    var sizes = $('[data-sizes]', form);
    var express = $('[data-express]', form);
    var atc = $('[data-atc]', form);
    var low = Number(form.getAttribute('data-low') || 5);
    var sticky = $('[data-sticky-atc="' + form.getAttribute('data-section') + '"]');

    function needSize() {
      if (hint) hint.hidden = false;
      if (sizes) {
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizes.classList.remove('shake');
        void sizes.offsetWidth;
        sizes.classList.add('shake');
        var firstFree = $('[data-size-input]:not([disabled])', sizes);
        if (firstFree) setTimeout(function () { firstFree.focus({ preventScroll: true }); }, 350);
      }
    }

    form.addEventListener('change', function (e) {
      var r = e.target.closest('[data-size-input]');
      if (!r) return;
      input.value = r.value;
      var qty = Number(r.getAttribute('data-qty') || 0);
      if (note) note.textContent = qty > 0 && qty <= low ? lowStockText(qty, r.getAttribute('data-size')) : '';
      if (hint) hint.hidden = true;
      if (express) express.hidden = false;
      if (sticky) {
        var s = $('[data-sticky-size]', sticky);
        if (s) s.textContent = r.getAttribute('data-size');
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input.value) { needSize(); return; }
      addToCart(input.value, atc);
    });

    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
      });
      io.observe(atc);
      var stickyBtn = $('[data-sticky-add]', sticky);
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (!input.value) { needSize(); return; }
          addToCart(input.value, stickyBtn);
        });
      }
    }
  }

  /* ------------------------------------------------------------------
     Galleria: contatore foto su mobile
  ------------------------------------------------------------------ */
  function initGallery(g) {
    if (g.__ready) return;
    g.__ready = true;
    var track = $('[data-gallery-track]', g);
    var current = $('[data-gallery-current]', g);
    if (!track || !current) return;
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var items = track.children;
        var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
        current.textContent = Math.min(items.length, Math.round(track.scrollLeft / Math.max(step, 1)) + 1);
      });
    }, { passive: true });
  }

  /* ------------------------------------------------------------------
     Video hero: parte solo a pagina caricata, versione leggera su telefono,
     niente video con "risparmio dati", rete lenta o movimento ridotto.
  ------------------------------------------------------------------ */
  function videoAllowed() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return false;
    return true;
  }

  function startVideo(v) {
    if (v.__started) return;
    v.__started = true;
    var desktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    var src = desktop ? v.getAttribute('data-src-desktop') : v.getAttribute('data-src-mobile');
    if (!src) return;
    var section = v.closest('section');
    var btn = section ? $('[data-video-toggle]', section) : null;
    var sync = function () {
      if (!btn) return;
      btn.textContent = v.paused ? (strings.play || 'Riproduci') : (strings.pause || 'Pausa');
      btn.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
    };
    v.addEventListener('playing', function () {
      v.classList.add('is-playing');
      if (btn) btn.hidden = false;
      sync();
    });
    v.addEventListener('pause', sync);
    if (btn && !btn.__ready) {
      btn.__ready = true;
      btn.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
    }
    v.preload = 'auto';
    v.src = src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function initVideo(scope) {
    var videos = $$('[data-hero-video]', scope);
    if (!videos.length || !videoAllowed()) return;
    var go = function () { videos.forEach(startVideo); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  /* ------------------------------------------------------------------
     Consegna prevista: giorni lavorativi (lun-ven), festività nazionali escluse
  ------------------------------------------------------------------ */
  var HOLIDAYS = ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26'];

  function addWorkingDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var key = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if (d.getDay() !== 0 && d.getDay() !== 6 && HOLIDAYS.indexOf(key) === -1) added++;
    }
    return d;
  }

  function initDelivery(scope) {
    if (!window.Intl || !Intl.DateTimeFormat) return;
    $$('[data-delivery]', scope).forEach(function (el) {
      var min = Number(el.getAttribute('data-min'));
      var max = Number(el.getAttribute('data-max'));
      if (!min || !max) return;
      var now = new Date();
      var a = addWorkingDays(now, Math.min(min, max));
      var b = addWorkingDays(now, Math.max(min, max));
      var dayOnly = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric' });
      var full = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
      var from = a.getMonth() === b.getMonth() ? dayOnly.format(a) : full.format(a);
      var tpl = strings.delivery || 'Ordina oggi, arriva tra [from] e [to].';
      el.textContent = tpl.replace('[from]', from).replace('[to]', full.format(b));
      el.hidden = false;
    });
  }

  /* ------------------------------------------------------------------
     Benvenuto: dopo qualche secondo, una volta ogni 30 giorni.
     Dopo l'iscrizione la pagina si ricarica e il foglio si riapre col codice.
  ------------------------------------------------------------------ */
  var WELCOME_KEY = 'seductive-welcome';

  function initWelcome() {
    var sheet = $('[data-drawer="welcome"]');
    if (!sheet) return;
    if ($('[data-welcome-success]', sheet)) {
      try { localStorage.setItem(WELCOME_KEY, String(Date.now())); } catch (e) {}
      openDrawer('welcome');
      return;
    }
    if (document.body.getAttribute('data-template') === 'cart') return;
    var last = 0;
    try { last = Number(localStorage.getItem(WELCOME_KEY) || 0); } catch (e) {}
    if (Date.now() - last < 30 * 864e5) return;
    var delay = Number(sheet.getAttribute('data-delay') || 20) * 1000;
    setTimeout(function () {
      if (openEl) return; // non interrompe chi sta scegliendo una taglia o guardando il carrello
      openDrawer('welcome');
      try { localStorage.setItem(WELCOME_KEY, String(Date.now())); } catch (e) {}
    }, delay);
  }

  /* ------------------------------------------------------------------
     Header: bordo quando si scorre
  ------------------------------------------------------------------ */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------------------
     Eventi globali (delegati)
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var copy = t.closest('[data-copy]');
    if (copy) {
      var text = copy.getAttribute('data-copy');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { toast(strings.copied || 'Codice copiato'); });
      }
      return;
    }

    var opener = t.closest('[data-drawer-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-drawer-open'), opener)) e.preventDefault();
      return;
    }

    if (t.closest('[data-drawer-close]') || t.matches('[data-overlay]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qa = t.closest('[data-qa-open]');
    if (qa) {
      var card = qa.closest('[data-card]');
      var tpl = card ? $('template[data-qa-template]', card) : null;
      var body = $('[data-qa-body]');
      if (tpl && body) {
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        openDrawer('quick-add', qa);
      }
      return;
    }

    var add = t.closest('[data-add-variant]');
    if (add && !add.disabled) {
      addToCart(add.getAttribute('data-add-variant'), add);
      return;
    }

    var change = t.closest('[data-line-change]');
    if (change) {
      changeLine(change.getAttribute('data-line'), change.getAttribute('data-qty'), change);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openEl) return;
    if (e.key === 'Escape') closeDrawer();
    else if (e.key === 'Tab') trapFocus(e);
  });

  function init(scope) {
    hoistDrawers(scope);
    $$('[data-product-form]', scope).forEach(initProductForm);
    $$('[data-gallery]', scope).forEach(initGallery);
    initVideo(scope);
    initDelivery(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    init(document);
    initWelcome();
  });

  // Editor del tema
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { if (openEl) closeDrawer(); });
})();
